import { Component } from '@angular/core';
import { RoutingService } from '../../../shared/services/routing.service';

@Component({
  selector: 'ppl-unauthorized',
  standalone: true,
  template: `
    <div class="unauthorized-container" role="alert">
      <i class="fa fa-exclamation-triangle warning-icon" aria-hidden="true"></i>
      <h2>Access Denied</h2>
      <p>You do not have permission to access this page. Contact your administrator if you believe this is an error.</p>
      <button class="btn btn-primary" (click)="goToDashboard()">Return to Dashboard</button>
    </div>
  `,
  styles: [`
    .unauthorized-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 80px 24px;
      text-align: center;
      color: #555;
    }
    .warning-icon {
      font-size: 48px;
      color: #faad14;
      margin-bottom: 16px;
    }
    h2 {
      margin-bottom: 8px;
      color: #333;
    }
    p {
      margin-bottom: 24px;
      max-width: 420px;
    }
  `],
})
export class UnauthorizedComponent {
  constructor(private router: RoutingService) {}

  goToDashboard(): void {
    this.router.navigate('/');
  }
}
